export default __webpack_public_path__ + "static/media/barbarianhead.cb689c4b.png";